import { Col, Form, Select, Spin } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import InputField from "../../../common/htmlComponents/InputField";
import { SuccessNotificationMsg } from "../../../utils/Notifications";

// State Initiailisation
const AddUnitOfMeasurement = ({
  handleCancel,
  setReload,
  unitOfMeasurementId,
  categoryTree,
  modalKey,
  setStateM,
  subCategoryTree
}) => {
  const { t } = useTranslation();

  const formRef = useRef();
  const initialState = {
    category_tree: 1,
    sub_category_name: "",
    unit_of_measurement: "",
    sub_category_id: null
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);

  // Fetch Material Type Getting By ID API
  useEffect(() => {
    const materialTypeGetById = async () => {
      if (unitOfMeasurementId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(
            `unit-of-measurement/${unitOfMeasurementId}/`
          );
          const { category_tree, category_tree_name, unit_of_measurement, sub_category_name, sub_category_id } = response.data.data;
          setState({ category_tree, category_tree_name, unit_of_measurement, sub_category_name, sub_category_id });
          formRef.current.setFieldsValue({
            category_tree: category_tree_name,
            category_tree_name: category_tree_name,
            unit_of_measurement,
            sub_category_name,
            sub_category_id
          });
          setapiLoading(false);
        } catch (error) {
          setapiLoading(false);
        }
      }
    };
    materialTypeGetById();
  }, [unitOfMeasurementId, modalKey]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Function TO Handle Input Change
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  // Function To Canllelation or Back To AddUnitOfMeasurementList
  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };

  // Function To Handle Submit Form
  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      console.log('state556', state);
      
      const {category_tree, sub_category_tree, unit_of_measurement} = state;


      const payload = {
        category_tree: state.category_tree,
        // sub_category: state.sub_category_tree,
        unit_of_measurement: state.unit_of_measurement
      };

      if (unitOfMeasurementId === null) {
        response = await postRequest("unit-of-measurement/", payload);
      } else {
        response = await patchRequest(
          `unit-of-measurement/${unitOfMeasurementId}/`,
          payload
        );
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          unitOfMeasurementId === null
            ? t("unit_of_measurement_added_successfully")
            : t("unit_of_measurement_updated_successfully")
        );

        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1
        }));
        formRef.current.setFieldsValue(initialState);

        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  return (
    <>
      <Spin spinning={apiLoading}>
        <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
          <Col md={24} className="TextFeild">
            <Form.Item
              name="category_tree"
              label={t("label_category")}
            >
              <Select
                showArrow
                showSearch
                allowClear
                // disabled
                defaultValue={1}
                placeholder="Select Caterory"
                optionFilterProp="children"
                onChange={(value) =>
                  setState({ ...state, category_tree: value })
                }
              >
                {categoryTree &&
                  categoryTree.length > 0 &&
                  categoryTree.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

        {/* Sub Category Dropdown */}
          {/* <Col md={24} className="TextFeild">
            <Form.Item
              name="sub_category_tree"
              label={t("label_category")}
            >
              <Select
                showArrow
                showSearch
                allowClear
                // disabled
                defaultValue={state.sub_category_id}
                placeholder="Select Sub Category"
                optionFilterProp="children"
                onChange={(value) =>
                  setState({ ...state, sub_category_tree: value })
                }
              >
                {subCategoryTree &&
                  subCategoryTree.length > 0 &&
                  subCategoryTree.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col> */}

          <Col md={24} className="TextFeild">
            <InputField
              name="unit_of_measurement"
              label={t("label_unit_of_measurement")}
              placeholder={t("pl_unit_of_measurement_enter")}
              handleInputChange={handleInputChange}
              rules={t("val_unit_of_measurement")}
              pattern="^[A-Za-z. ]+$"
              max={16}
            />
          </Col>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />

            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("save")}
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddUnitOfMeasurement.propTypes = {
  handleCancel: PropTypes.func,
  setReload: PropTypes.func,
  unitOfMeasurementId: PropTypes.number,
  categoryTree: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  subCategoryTree: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func.isRequired
};

export default AddUnitOfMeasurement;
